import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Col, Row } from 'antd'
import '../../css/company.scss'
import ActionCase from '../../component/actioncase/actionCase'

const Case = (props) => {
  return (
    <Row className='customersRow'>
      <Col flex={'auto'}>
        <ActionCase />
      </Col>
    </Row>
  )
}

Case.propTypes = {}

export default connect(null, null)(Case)
